import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const EmailSignupForm_Box_1 = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin-top: 40px;
  }
`;
